import "./GarageDoorServiceMaintenance.module.css";
import Header from "@/reusable_sections/Header";
import GarageHero from "./sections/GarageHero";
import GarageServices from "./sections/GarageServices";
import ServiceChecklist from "./sections/ServiceChecklist";
import ServicePlans from "./sections/ServicePlans";
import GarageProcess from "./sections/GarageProcess";
import GarageWhyUs from "./sections/GarageWhyUs";
import GarageComparison from "./sections/GarageComparison";
import GarageTestimonials from "./sections/GarageTestimonials";
import GarageFaq from "./sections/GarageFaq";
import GarageCta from "./sections/GarageCta";
import GarageFooter from "./sections/GarageFooter";
import ServiceAreas from "./sections/ServiceAreas";
export default function GarageDoorServiceMaintenancePage() {
  return <div>
      <Header />
      <GarageHero />
      <GarageServices />
      <ServiceChecklist />
      <ServicePlans />
      <GarageProcess />
      <GarageWhyUs />
      <GarageComparison />
      <GarageTestimonials />
      <ServiceAreas />
      <GarageFaq />
      <GarageCta />
      <GarageFooter />
    </div>;
}